export interface PIIUserProfile {
  id?: string
  grootUid: string
  firstName?: string
  lastName?: string
  email: string
  dob?: string | null
  gender?: string
  countryCode?: string
  stateCode?: string
  createdAt?: string
  updatedAt?: string
}

export interface UpdatePIIUser {
  firstName?: string
  lastName?: string
  dob?: string
  gender?: string
  countryCode?: string
  stateCode?: string
}

export enum GenderEnums {
  Male = 'male',
  Female = 'female',
  Other = 'other',
  PreferNotToSay = 'prefer_not_to_say',
  NonBinary = 'non_binary',
}

export enum IdmeUserGroup {
  MILITARY = 'military',
  STUDENT = 'student',
  RESPONDER = 'responder',
}

export type UserGroup = `${IdmeUserGroup}` | null

export interface UpdateUserIdmeResult {
  grootUid?: string | null
  idmeId: string | null
  userGroup: UserGroup
}

export interface UserProfile extends Omit<PIIUserProfile, 'firstName' | 'lastName' | 'email'> {}
